module.exports = __webpack_public_path__ + "static/img/digital03.22be3a76.png";